import { DefaultButton } from '@micro-frontend-react/employee-experience/lib/Buttons/DefaultButton';

export const QuestionLink = styled(DefaultButton)`
  font-weight: 600;
  text-align: left;
  height: auto;
  min-width: 0;
  color: rgb(0, 80, 169);
  padding: 0;
  border: 0;
  margin-top: 15px;
  margin-left: 0;

  & span {
    margin-left: 0;
  }

  &&&:hover {
    background-color: transparent;
    color: rgb(0, 80, 169);
    text-decoration: underline;
  }
`;

export const QuestionTitle = styled.h2`
  margin-bottom: 20px;
`;
